<template>
  <div
    class="escalator-settings"
    v-loading.fullscreen.lock="loading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
  >
    <el-dialog
      :title="$l('远程设置') + '(' + settings.jobNum + ')'"
      :visible.sync="dialogVisible"
      width="800px"
      @close="close"
    >
      <el-tabs
        ref="settingTabs"
        :tab-position="tabPosition"
        :stretch="false"
        v-model="settings.item"
      >
        <el-tab-pane
          :label="$l('栏杆照明')"
          v-if="elevatorFunction.lightingOfRailings"
          name="0"
        >
          <div class="content-top">
            <h3>{{ $l("栏杆照明") }}</h3>
            <p>{{ $l("设置栏杆照明的自动开关时间以及颜色切换计划。") }}</p>
          </div>
          <div class="content-center">
            <p>
              <span class="item-label">{{ $l("是否启用") }}</span>
              <el-switch v-model="settings.lightEnabled" />
            </p>
          </div>
        </el-tab-pane>
        <el-tab-pane
          :label="$l('彩色栏杆照明')"
          v-if="elevatorFunction.railingLightingColour"
          :name="'1'"
        >
          <div class="content-top">
            <h3>{{ $l("彩色栏杆照明") }}</h3>
          </div>
          <div class="content-center">
            <p>
              <span class="item-label">{{ $l("是否启用") }}</span>
              <el-switch v-model="settings.colorEnabled" />
            </p>
            <!-- <p>
              <span class="item-label" :title="$l('彩色栏杆')">{{
                $l("彩色栏杆")
              }}</span>
              <el-select v-model="settings.type">
                <el-option :label="$l('普通栏杆')" value="1"> </el-option
                ><el-option :label="$l('彩色栏杆')" value="2"> </el-option>
              </el-select>
            </p> -->
            <p v-if="settings.colorType == 2">
              <span class="item-label" :title="$l('模式')">{{
                $l("模式")
              }}</span>
              <el-select v-model="settings.colorMode">
                <el-option :label="$l('静态红色')" value="1"> </el-option>
                <el-option :label="$l('静态绿色')" value="2"> </el-option>
                <el-option :label="$l('静态蓝色')" value="3"> </el-option>
                <el-option :label="$l('静态黄色')" value="4"> </el-option>
                <el-option :label="$l('静态青色')" value="5"> </el-option>
                <el-option :label="$l('静态紫色')" value="6"> </el-option>
                <el-option :label="$l('红绿蓝三色跳变')" value="7"> </el-option>
                <el-option :label="$l('红绿蓝三色渐变')" value="8"> </el-option>
                <el-option :label="$l('红色向左跑马')" value="9"> </el-option>
                <el-option :label="$l('绿色向左跑马')" value="10"> </el-option>
                <el-option :label="$l('蓝色向左跑马')" value="11"> </el-option>
                <el-option :label="$l('黄色向左跑马')" value="12"> </el-option>
                <el-option :label="$l('青色向左跑马')" value="13"> </el-option>
                <el-option :label="$l('紫色向左跑马')" value="14"> </el-option>
                <el-option :label="$l('红色向右跑马')" value="15"> </el-option>
                <el-option :label="$l('绿色向右跑马')" value="16"> </el-option>
                <el-option :label="$l('蓝色向右跑马')" value="17"> </el-option>
                <el-option :label="$l('黄色向右跑马')" value="18"> </el-option>
                <el-option :label="$l('青色向右跑马')" value="19"> </el-option>
                <el-option :label="$l('紫色向右跑马')" value="20"> </el-option>
                <el-option :label="$l('红色向左流水')" value="21"> </el-option>
                <el-option :label="$l('绿色向左流水')" value="22"> </el-option>
                <el-option :label="$l('蓝色向左流水')" value="23"> </el-option>
                <el-option :label="$l('黄色向左流水')" value="24"> </el-option>
                <el-option :label="$l('青色向左流水')" value="25"> </el-option>
                <el-option :label="$l('紫色向左流水')" value="26"> </el-option>
                <el-option :label="$l('红色向右流水')" value="27"> </el-option>
                <el-option :label="$l('绿色向右流水')" value="28"> </el-option>
                <el-option :label="$l('蓝色向右流水')" value="29"> </el-option>
                <el-option :label="$l('黄色向右流水')" value="30"> </el-option>
                <el-option :label="$l('青色向右流水')" value="31"> </el-option>
                <el-option :label="$l('紫色向右流水')" value="32"> </el-option>
                <el-option :label="$l('七彩渐变')" value="33"> </el-option>
                <el-option :label="$l('七彩流水')" value="34"> </el-option>
                <el-option :label="$l('七彩跳变')" value="35"> </el-option>
                <el-option :label="$l('1.1米分段全彩扫描')" value="36">
                </el-option>
              </el-select>
            </p>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$l('停止前低速运行时间')" :name="'2'">
          <div class="content-top">
            <h3>{{ $l("停止前低速运行时间") }}</h3>
            <p>
              {{
                $l(
                  "根据人流量的高峰、闲时设置此时间，避免频繁加减速，节约电能。"
                )
              }}
            </p>
          </div>
          <div class="content-center">
            <p>
              <span class="run-time-label" :title="$l('停止前低速运行时间')">{{
                $l("停止前低速运行时间")
              }}</span>
              <el-input-number
                v-model="settings.lowSpeedTime"
                :min="12"
                :max="600"
                :controls="false"
              />&nbsp;&nbsp;
              <span>{{ $l("范围：12~600秒") }}</span>
            </p>
          </div>
        </el-tab-pane>
        <el-tab-pane
          :label="$l('分时段节能模式')"
          v-if="elevatorFunction.itStopsAutomatically"
          :name="'3'"
        >
          <div class="content-top">
            <h3>{{ $l("分时段节能模式") }}</h3>
            <p>{{ $l("分时间设置自动低速及自动停止两种节能模式。") }}</p>
          </div>
          <div class="content-center">
            <p>
              <span class="item-label" :title="$l('节能模式')">{{
                $l("节能模式")
              }}</span>
              <el-select v-model="settings.energyMode">
                <el-option :label="$l('自动停止')" value="1"> </el-option
                ><el-option :label="$l('自动低速')" value="2"> </el-option>
              </el-select>
            </p>
            <p v-if="settings.energyMode == 2">
              <el-select v-model="settings.period">
                <el-option :label="$l('时间段1')" value="1" />
                <el-option :label="$l('时间段2')" value="2" /> </el-select
              >&nbsp;&nbsp;
              <el-time-picker
                v-model="settings.energyStartTime"
                format="HH:mm"
                value-format="HH:mm"
                :picker-options="{
                  selectableRange: '00:00:00 - 23:59:59',
                }"
              >
              </el-time-picker>
              <span>&nbsp;--&nbsp;</span>
              <el-time-picker
                v-model="settings.energyEndTime"
                format="HH:mm"
                value-format="HH:mm"
                :picker-options="{
                  selectableRange: '00:00:00 - 23:59:59',
                }"
              >
              </el-time-picker>
            </p>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$l('定时启停设置')" :name="'4'">
          <div class="content-top">
            <h3>{{ $l("定时启停设置") }}</h3>
            <p>{{ $l("设置每天关梯时间，到达时间范围自动关梯。") }}</p>
          </div>
          <div class="content-center">
            <p v-if="elevatorFunction.aisecurityVisualization">
              <span class="item-label">{{ $l("扶梯启动") }}</span>
              <el-switch v-model="settings.onEnable" />
            </p>
            <p
              v-if="
                settings.onEnable && elevatorFunction.aisecurityVisualization
              "
            >
              <span class="item-label">{{ $l("关机时间") }}</span>
              <el-time-picker
                v-model="settings.onTime"
                format="HH:mm"
                value-format="HH:mm"
                :picker-options="{
                  selectableRange: '00:00:00 - 23:59:59',
                }"
              >
              </el-time-picker>
              &nbsp;&nbsp;
              <el-select v-model="settings.onMode">
                <el-option :label="$l('上行启动')" value="1" />
                <el-option :label="$l('下行启动')" value="2" />
              </el-select>
            </p>
            <p>
              <span class="item-label">{{ $l("扶梯停梯") }}</span>
              <el-switch v-model="settings.offEnable" />
            </p>
            <p v-if="settings.offEnable">
              <span class="item-label">{{ $l("关梯时间") }}</span>
              <el-time-picker
                v-model="settings.offTime"
                format="HH:mm"
                value-format="HH:mm"
                :picker-options="{
                  selectableRange: '00:00:00 - 23:59:59',
                }"
              >
              </el-time-picker>
            </p>
          </div>
        </el-tab-pane>
        <el-tab-pane
          :label="$l('语音内容')"
          v-if="elevatorFunction.voiceFunction"
          :name="'5'"
        >
          <div class="content-top">
            <h3>{{ $l("语音内容") }}</h3>
            <p>{{ $l("下发语音代码") }}</p>
          </div>
          <div class="content-center">
            <p>
              <span class="item-label" :title="$l('场景')">{{
                $l("场景")
              }}</span>
              <el-select v-model="settings.sceneNum" class="work-status-select">
                <el-option :label="$l('1 正向高速运行提示语')" value="1" />
                <el-option :label="$l('2 逆向进入提示语')" value="2" />
                <el-option :label="$l('3 正向加速提示语')" value="3" />
                <el-option :label="$l('4 故障停梯提示语')" value="4" />
                <el-option :label="$l('5 远程启动提示语')" value="5" />
                <el-option :label="$l('6 远程停止提示语')" value="6" />
              </el-select>
            </p>
            <p>
              <span class="item-label" :title="$l('扶梯工况')">{{
                $l("扶梯工况")
              }}</span>
              <el-select v-model="settings.voiceNum" class="work-status-select">
                <el-option
                  :label="
                    $l(
                      '01 请站稳扶好，勿将头手伸出扶手带以外，照顾好老人与小孩，勿携带大件行李乘坐扶梯'
                    )
                  "
                  value="1"
                />
                <el-option
                  :label="$l('05 请注意，勿将头手伸出扶手带以外')"
                  value="5"
                />
                <el-option
                  :label="
                    $l(
                      '06 乘客请注意，扶梯正在加速，请站稳扶好，双脚站在梯级的黄色界限内'
                    )
                  "
                  value="6"
                />
                <el-option
                  :label="$l('08 乘客请注意，不能由此方向进入扶梯')"
                  value="8"
                />
                <el-option
                  :label="$l('09 各位乘客请注意，扶梯即将启动，请暂勿使用扶梯')"
                  value="9"
                />
                <el-option
                  :label="$l('10 各位乘客请注意，扶梯即将停止，请暂勿使用扶梯')"
                  value="10"
                />
                <el-option
                  :label="
                    $l(
                      '11 扶梯已停止，为了您的安全，请使用楼梯或直梯，谢谢配合'
                    )
                  "
                  value="11"
                />
                <el-option :label="$l('17 哒哒哒(前进)')" value="17" />
                <el-option :label="$l('18 哒-哒-哒(禁止)')" value="18" />
                <el-option
                  :label="$l('19 哒-哒-哒(上部_禁止) 哒哒哒(下部_前进)')"
                  value="19"
                />
                <el-option
                  :label="$l('20 哒哒哒(上部_前进) 哒-哒-哒(下部_等待)')"
                  value="20"
                />
              </el-select>
            </p>
          </div>
        </el-tab-pane>
        <el-tab-pane
          :label="$l('语音音量')"
          v-if="elevatorFunction.voiceFunction"
          :name="'6'"
        >
          <div class="content-top">
            <h3>{{ $l("语音音量") }}</h3>
            <p>{{ $l("根据时段设置音量，避免安静环境下的嘈扰。") }}</p>
          </div>
          <div class="content-center">
            <p>
              <span class="item-label" :title="$l('播放音量')">{{
                $l("播放音量")
              }}</span>
              <el-input-number
                v-model="settings.volume"
                :min="0"
                :max="9"
                :controls="false"
              />&nbsp;&nbsp;
              <span
                class="volume-range-tip"
                :title="
                  $l(
                    '范围：0~9（时间段为空设定默认语音音量，0则代表设定默认语音音量，非0则设置指定时间段音量）'
                  )
                "
                >{{
                  $l(
                    "范围：0~9（时间段为空设定默认语音音量，0则代表设定默认语音音量，非0则设置指定时间段音量）"
                  )
                }}</span
              >
            </p>
            <p>
              <span class="item-label">{{ $l("时间段") }}</span>
              <el-time-picker
                v-model="settings.voiceStartTime"
                format="HH:mm"
                value-format="HH:mm"
                :picker-options="{
                  selectableRange: '00:00:00 - 23:59:59',
                }"
              >
              </el-time-picker
              >&nbsp;--&nbsp;
              <el-time-picker
                v-model="settings.voiceEndTime"
                format="HH:mm"
                value-format="HH:mm"
                :picker-options="{
                  selectableRange: '00:00:00 - 23:59:59',
                }"
              >
              </el-time-picker>
            </p>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$l('反向进入运行动作')" :name="'7'">
          <div class="content-top">
            <h3>{{ $l("反向进入运行动作") }}</h3>
            <p>{{ $l("用户反向进入时，运行动作设置。") }}</p>
          </div>
          <div class="content-center">
            <p>
              <span class="run-action-label" :title="$l('反向进入运行动作')">{{
                $l("反向进入运行动作")
              }}</span>
              <el-select v-model="settings.action">
                <el-option :label="$l('蜂鸣')" value="1" />
                <el-option :label="$l('高速运行')" value="2" />
                <el-option :label="$l('高速运行+蜂鸣')" value="3" />
              </el-select>
            </p>
          </div>
        </el-tab-pane>
        <el-tab-pane
          :label="$l('运行速度')"
          v-if="elevatorFunction.fullFrequencyConversion"
          :name="'8'"
        >
          <div class="content-top">
            <h3>{{ $l("运行速度") }}</h3>
            <p>{{ $l("根据电梯额定速度范围，设置最高速度设置。") }}</p>
          </div>
          <div class="content-center">
            <p>
              <el-select v-model="settings.config">
                <el-option :label="$l('第2运行速度')" value="1" />
                <el-option :label="$l('第3运行速度')" value="2" /> </el-select
              >&nbsp;&nbsp; <span>{{ $l("运行速度") }}</span
              >&nbsp;&nbsp;
              <el-input-number
                v-model="settings.speed"
                :min="15"
                :max="49"
                :controls="false"
              />&nbsp;&nbsp;
              <span>{{ $l("范围：15-49") }}（米/min）</span>
            </p>
          </div>
        </el-tab-pane>
        <el-tab-pane
          :label="$l('AI自动运行模式')"
          v-if="elevatorFunction.aisecurityVisualization"
          :name="'9'"
        >
          <div class="content-top">
            <h3>{{ $l("AI自动运行模式") }}</h3>
          </div>
          <div class="content-center">
            <p>
              <span class="item-label">{{ $l("是否启用") }}</span>
              <el-switch v-model="settings.aiEnabled" />
            </p>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$l('扶梯上有无人确认')" :name="'10'">
          <div class="content-top">
            <h3>{{ $l("扶梯上有无人确认") }}</h3>
          </div>
          <div class="content-center">
            <p>
              <span class="item-label">{{ $l("有无人") }}</span>
              <el-switch v-model="settings.hasExist" />
              <el-button
                round
                type="primary"
                outline
                @click="timing(true)"
                style="margin-left: 45px"
                >{{ $l("主板对时") }}
              </el-button>
            </p>
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-button class="submit-btn" round type="primary" @click="submitSetting"
        >{{ $l("确定") }}
      </el-button>
    </el-dialog>
  </div>
</template>

<script>
import global from "@/mixins/global.js";
export default {
  name: "escalatorSettings",
  mixins: [global],
  props: {
    data: {
      type: Object,
      default: {
        jobNum: "",
      },
    },
  },
  data() {
    return {
      tabPosition: "left",
      settings: {
        jobNum: "",
        lightEnabled: true,
        colorEnabled: true,
        aiEnabled: true,
        colorType: 2,
        lowSpeedTime: 60,
        period: "1",
        colorMode: "1",
        energyMode: "1",
        sceneNum: "1",
        voiceNum: "1",
        volume: 1,
        action: "1",
        config: "1",
        speed: 15,
        onEnable: false,
        offEnable: false,
        onMode: "1",
        onTime: null,
        offTime: null,
        energyStartTime: null,
        energyEndTime: null,
        voiceStartTime: null,
        voiceEndTime: null,
        hasExist: true,
        item: "0",
      },
      dialogVisible: false,
      loading: false,
      elevatorFunction: {},
    };
  },
  mounted() {},
  methods: {
    submitSetting() {
      if (this.settings.item == "3" && this.settings.energyMode == "2") {
        if (
          this.settings.energyStartTime == null ||
          this.settings.energyEndTime == null
        ) {
          this.message(1, "请设置时间段，必须同时设置开始时间和结束时间");
          return;
        }
        if (
          this.$common.compareTime(
            this.settings.energyStartTime,
            this.settings.energyEndTime
          ) >= 0
        ) {
          this.message(1, "时间段的开始时间不能大于或等于结束时间");
          return;
        }
      }
      if (this.settings.item == "4") {
        if (this.settings.onEnable && this.settings.onTime == null) {
          this.message(1, "请设置扶梯启动时间");
          return;
        }
        if (this.settings.offEnable && this.settings.offTime == null) {
          this.message(1, "请设置扶梯停梯时间");
          return;
        }
      }
      if (this.settings.item == "6") {
        if (
          this.settings.voiceStartTime == null &&
          this.settings.voiceEndTime != null
        ) {
          this.message(1, "请输入起始时间");
          return;
        }
        if (
          this.settings.voiceStartTime != null &&
          this.settings.voiceEndTime == null
        ) {
          this.message(1, "请输入结束时间");
          return;
        }
        if (
          this.settings.voiceStartTime != null &&
          this.settings.voiceEndTime != null
        ) {
          if (
            this.$common.compareTime(
              this.settings.voiceStartTime,
              this.settings.voiceEndTime
            ) >= 0
          ) {
            this.message(1, "时间段的开始时间不能大于或等于结束时间");
            return;
          }
        }
      }
      this.loading = true;
      this.$http
        .post(this.$apiConfig.escalator_settings_url, this.settings)
        .then((response) => {
          this.loading = false;
          let result = response.data;
          this.message(result.code, result.msg);
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage(0);
          this.$sentry.captureException(error);
        });
    },
    open(jobNum) {
      this.settings.jobNum = jobNum;
      this.loading = true;
      this.$http
        .get(this.$apiConfig.get_elevator_function_url, {
          params: {
            jobNum: this.settings.jobNum,
          },
        })
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.elevatorFunction = result.data;
            // this.elevatorFunction.lightingOfRailings = false;
            // this.elevatorFunction.railingLightingColour = false;
            // this.elevatorFunction.itStopsAutomatically = false;
            // this.elevatorFunction.fullFrequencyConversion = false;
            // this.elevatorFunction.voiceFunction = false;
            // this.elevatorFunction.aisecurityVisualization = false;
            if (!this.elevatorFunction.aisecurityVisualization) {
              this.settings.onEnable = null;
            }
          } else {
            this.message(result.code, result.msg);
          }
          this.timing(false);
          this.getEscalatorSettings();
        })
        .catch((error) => {
          this.timing(false);
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    timing(isTip) {
      this.loading = true;
      this.$http
        .get(this.$apiConfig.timing_url, {
          params: {
            jobNum: this.settings.jobNum,
          },
        })
        .then((response) => {
          this.loading = false;
          this.dialogVisible = true;
          let result = response.data;
          if (result.code != 0 || isTip) {
            this.message(result.code, result.msg);
          }
          if (!isTip) {
            this.$nextTick(() => {
              const panes = this.$refs.settingTabs.panes;
              if (panes.length > 0) {
                this.settings.item = panes[0].name;
              }
            });
          }
        })
        .catch((error) => {
          this.loading = false;
          this.dialogVisible = true;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    getEscalatorSettings() {
      this.$http
        .get(this.$apiConfig.get_escalator_settings_url, {
          params: {
            jobNum: this.settings.jobNum,
          },
        })
        .then((response) => {
          let result = response.data;
          if (result.code == 0) {
            for (const key in this.settings) {
              if (key in result.data) {
                this.settings[key] = result.data[key];
              }
            }
          }
        })
        .catch((error) => {
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    close() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss">
.escalator-settings {
  .el-dialog__body {
    position: relative;
    padding-bottom: 20px !important;
    .submit-btn {
      position: absolute;
      bottom: 20px;
      right: 30px;
    }
  }
  .el-tabs {
    .el-tabs__header {
      background-color: #f2f2f2;
      border-radius: 10px;
      .is-active {
        background-color: #fafafa;
      }
      .el-tabs__nav-wrap::after {
        background-color: unset !important;
      }
      .el-tabs__nav-wrap.is-left {
        padding-top: 10px;
      }
      .el-tabs__active-bar.is-left {
        right: 1px;
      }
      .el-tabs__item.is-left {
        max-width: 200px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .el-tabs__content {
      padding-top: 10px;
      padding-left: 30px;
      .content-top {
        h3 {
          color: black;
          font-weight: unset;
        }
        p {
          color: #999;
          font-size: 13px;
        }
      }
      .content-center {
        margin-top: 30px;
        .el-date-editor {
          width: 120px;
          .el-input__icon {
            line-height: 32px;
          }
        }
        p {
          display: flex;
          justify-items: center;
          align-items: center;
          margin-bottom: 20px;
          font-size: 13px;
          span.item-label {
            display: inline-block;
            text-align: left;
            width: 90px;
          }
          .run-time-label {
            display: inline-block;
            text-align: left;
            width: 140px;
          }
          .run-action-label {
            display: inline-block;
            text-align: left;
            width: 120px;
          }
          .adaptive-label {
            display: inline-block;
            text-align: left;
            width: 60px;
          }
          span {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .el-select {
          width: 140px;
        }
        .el-input__inner {
          height: 30px;
        }
        .el-icon-arrow-up {
          margin-top: 2px;
        }
        .el-icon-arrow-up.is-reverse {
          margin-top: -3px;
        }
        .work-status-select {
          width: 200px;
        }
        .el-upload {
          float: left;
          .el-button {
            height: 28px;
            line-height: 8px;
            border-radius: 20px;
          }
        }
        .voice-upload-tip {
          height: 30px;
          line-height: 30px;
        }
        .volume-range-tip {
          display: block;
          float: right;
          width: 260px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
</style>
